const CondensedMenu = (): React.JSX.Element | null => {
  return null;
};

export default CondensedMenu;
